import BaseVirtualLineForm from "./base_virtual_line_form";

export default class EditVirtualLineForm extends BaseVirtualLineForm {
  initialize(...args) {
    super.initialize(...args);

    this.config = args[0].config;

    if (!this.model) {
      throw new Error("model must be provided");
    }
    this.templateConfig = {
      displayPromoType: false,
      manageVirtualLines: this.config.manageVirtualLines,
      defaultAdwordsAccount: this.defaultAdwordsAccount(this.config.availableAccounts),
      accountsListUrl: this.config.accountsListUrl,
      advertiser_campaign_name: this.model.get('advertiser_campaign_name'),
      affiliate_campaign_name: this.model.get('affiliate_id') !== null ? this.model.get('campaign_name') : null,
      promo_number: this.model.get('virtual_line_name') || this.model.get('promo_number'),
      media_type: this.model.get('media_type')
    };
  }
}
